/**
 * Threshold decryption of ECIES boxes without reconstructing the secret.
 *
 * Confidant i holds share s_i of sk. For a box with ephemeral point R:
 *   partial_i = s_i · R                        (computed on the confidant's device)
 *   S = Σ λ_i · partial_i = sk · R             (combined by the requester)
 * Partials are bound to one R, so approving one window never helps with another.
 */
import { pointAdd, pointMul, pointZero, scalarFromBytes } from "./group.js";
import { openWithShared } from "./ecies.js";
import { lagrangeAtZero } from "./shamir.js";
export function partialDecrypt(share, sealed) {
    return { index: share.index, value: pointMul(sealed.ephemeral, scalarFromBytes(share.value)) };
}
/** Combine k partials into the shared point S. Throws on duplicate indices. */
export function combinePartials(partials) {
    if (partials.length === 0)
        throw new RangeError("no partials");
    const lambda = lagrangeAtZero(partials.map((p) => p.index));
    let acc = pointZero();
    for (const p of partials) {
        acc = pointAdd(acc, pointMul(p.value, lambda.get(p.index)));
    }
    return acc;
}
/** Open a sealed box using k partials. Fails authentication if fewer than k valid partials. */
export function thresholdOpen(publicKey, sealed, partials, aad) {
    return openWithShared(combinePartials(partials), publicKey, sealed, aad);
}
//# sourceMappingURL=threshold.js.map